import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import CodeMappingViewForm from './CodeMappingViewForm'
import CodeMappingAddForm from './CodeMappingAddForm'
import CodeMappingEditForm from './CodeMappingEditForm'
import Namespace from 'src/constants/locale/Namespace'
import CodeMappingKeys from 'src/constants/locale/key/CodeMapping'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [codeMappingId, setCodeMappingId] = useState('')
  const { translate } = useTranslation([
    Namespace.CODE_MAPPING,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let codeMapping = translate(
      Namespace.CODE_MAPPING,
      CodeMappingKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: codeMapping
      }
    )

    return {
      codeMapping,
      tabLockedMessage
    }
  }

  function makeCodeMappingForm() {
    if (codeMappingId === '') {
      return (
        <CodeMappingAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setCodeMappingId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <CodeMappingEditForm
          showNotification={showNotification}
          id={codeMappingId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CodeMappingViewForm
              showNotification={showNotification}
              id={codeMappingId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.codeMapping,
              tabContent: makeCodeMappingForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage